<template>
  <div class="flyGreenBooking">
    <div class="flyGreenBooking__left">
      <div class="flyGreenBooking__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="105" height="104" viewBox="0 0 105 104" fill="none">
          <path
            transform="scale(0.9),translate(8,4)"
            d="M32.0205 55.0332H28.1514V58.998H25.752V49.0449H32.4102V50.8975H28.1514V53.1875H32.0205V55.0332ZM35.8076 57.1523H39.9844V58.998H33.4082V49.0449H35.8076V57.1523ZM42.7256 53.3652L44.5576 49.0449H47.1484L43.9424 55.4229V58.998H41.5088V55.4229L38.3096 49.0449H40.8867L42.7256 53.3652ZM55.8164 57.7676C55.4473 58.1777 54.9072 58.5081 54.1963 58.7588C53.4854 59.0094 52.7061 59.1348 51.8584 59.1348C50.555 59.1348 49.5137 58.736 48.7344 57.9385C47.9551 57.141 47.5381 56.0312 47.4834 54.6094L47.4766 53.748C47.4766 52.7682 47.6497 51.9137 47.9961 51.1846C48.3424 50.4508 48.8369 49.888 49.4795 49.4961C50.1266 49.0996 50.874 48.9014 51.7217 48.9014C52.9613 48.9014 53.9229 49.1862 54.6064 49.7559C55.2946 50.321 55.6956 51.1663 55.8096 52.292H53.499C53.417 51.736 53.2393 51.3395 52.9658 51.1025C52.6924 50.8656 52.305 50.7471 51.8037 50.7471C51.2021 50.7471 50.7373 51.0023 50.4092 51.5127C50.0811 52.0231 49.9147 52.7523 49.9102 53.7002V54.3018C49.9102 55.2952 50.0788 56.0426 50.416 56.5439C50.7578 57.0407 51.2933 57.2891 52.0225 57.2891C52.6468 57.2891 53.1117 57.1501 53.417 56.8721V55.3271H51.749V53.6797H55.8164V57.7676ZM61.5791 53.6865L60.8203 53.6318C60.0957 53.6318 59.6309 53.8597 59.4258 54.3154V58.998H57.1221V51.6016H59.2822L59.3574 52.5518C59.7448 51.8271 60.2848 51.4648 60.9775 51.4648C61.2236 51.4648 61.4378 51.4922 61.6201 51.5469L61.5791 53.6865ZM65.8516 59.1348C64.7168 59.1348 63.7985 58.7975 63.0967 58.123C62.3949 57.444 62.0439 56.5622 62.0439 55.4775V55.2861C62.0439 54.5296 62.1829 53.862 62.4609 53.2832C62.7435 52.7044 63.1536 52.2578 63.6914 51.9434C64.2292 51.6243 64.8672 51.4648 65.6055 51.4648C66.6445 51.4648 67.4648 51.7884 68.0664 52.4355C68.668 53.0781 68.9688 53.9759 68.9688 55.1289V56.0244H64.3887C64.4707 56.4391 64.6507 56.765 64.9287 57.002C65.2067 57.2389 65.5667 57.3574 66.0088 57.3574C66.738 57.3574 67.3076 57.1022 67.7178 56.5918L68.7705 57.8359C68.4834 58.2324 68.0755 58.5492 67.5469 58.7861C67.0228 59.0186 66.4577 59.1348 65.8516 59.1348ZM65.5918 53.2422C64.9173 53.2422 64.5163 53.6888 64.3887 54.582H66.7129V54.4043C66.722 54.0352 66.6286 53.7503 66.4326 53.5498C66.2367 53.3447 65.9564 53.2422 65.5918 53.2422ZM73.4805 59.1348C72.3457 59.1348 71.4274 58.7975 70.7256 58.123C70.0238 57.444 69.6729 56.5622 69.6729 55.4775V55.2861C69.6729 54.5296 69.8118 53.862 70.0898 53.2832C70.3724 52.7044 70.7826 52.2578 71.3203 51.9434C71.8581 51.6243 72.4961 51.4648 73.2344 51.4648C74.2734 51.4648 75.0938 51.7884 75.6953 52.4355C76.2969 53.0781 76.5977 53.9759 76.5977 55.1289V56.0244H72.0176C72.0996 56.4391 72.2796 56.765 72.5576 57.002C72.8356 57.2389 73.1956 57.3574 73.6377 57.3574C74.3669 57.3574 74.9365 57.1022 75.3467 56.5918L76.3994 57.8359C76.1123 58.2324 75.7044 58.5492 75.1758 58.7861C74.6517 59.0186 74.0866 59.1348 73.4805 59.1348ZM73.2207 53.2422C72.5462 53.2422 72.1452 53.6888 72.0176 54.582H74.3418V54.4043C74.3509 54.0352 74.2575 53.7503 74.0615 53.5498C73.8656 53.3447 73.5853 53.2422 73.2207 53.2422ZM79.6465 51.6016L79.7217 52.4697C80.2321 51.7998 80.9362 51.4648 81.834 51.4648C82.6042 51.4648 83.1784 51.695 83.5566 52.1553C83.9395 52.6156 84.1377 53.3083 84.1514 54.2334V58.998H81.8408V54.3291C81.8408 53.9554 81.7656 53.682 81.6152 53.5088C81.4648 53.3311 81.1914 53.2422 80.7949 53.2422C80.3438 53.2422 80.0088 53.4199 79.79 53.7754V58.998H77.4863V51.6016H79.6465Z"
            fill="#13A355"/>
          <path d="M92.0843 67.6598C89.0687 75.4288 83.7161 82.0724 76.7639 86.675C69.8117 91.2777 61.602 93.613 53.266 93.3592C44.93 93.1054 36.8779 90.275 30.219 85.258C23.5602 80.2409 18.6224 73.2841 16.0858 65.346C15.9661 65.0042 15.7176 64.7226 15.3933 64.561C15.0689 64.3995 14.6943 64.3707 14.3491 64.4809C14.0039 64.5911 13.7153 64.8315 13.5448 65.1511C13.3742 65.4706 13.3352 65.844 13.436 66.1918C16.1544 74.6905 21.4477 82.1358 28.5842 87.4987C35.7208 92.8617 44.3483 95.8775 53.2745 96.1294C62.2007 96.3813 70.9848 93.8568 78.4129 88.9049C85.8411 83.9529 91.5464 76.818 94.7406 68.4862L97.384 69.3028L98.0002 53.7251L89.6518 66.9047L92.0843 67.6598Z" fill="url(#paint0_linear_4874_2209)"/>
          <path d="M41.6984 11.941C35.4716 13.8763 29.7655 17.1981 25.0098 21.6562C20.2542 26.1142 16.5729 31.5924 14.2434 37.6781L11.6195 36.8614L11 52.4489L19.3322 39.2595L16.9094 38.5142C19.9336 30.7201 25.3093 24.0589 32.2917 19.4538C39.274 14.8487 47.5172 12.5278 55.8787 12.8126C64.2402 13.0975 72.3059 15.9741 78.9581 21.0437C85.6103 26.1133 90.5194 33.1249 93.0052 41.1067C93.1269 41.4429 93.3738 41.7193 93.6945 41.878C94.0152 42.0367 94.3848 42.0656 94.7262 41.9586C95.0677 41.8515 95.3546 41.6169 95.5271 41.3036C95.6995 40.9903 95.7442 40.6225 95.6518 40.2771C93.9716 34.8767 91.2432 29.8599 87.6224 25.5131C84.0015 21.1663 79.5592 17.5748 74.5491 14.9435C69.539 12.3122 64.0592 10.6927 58.4227 10.1776C52.7861 9.66241 47.1032 10.2616 41.6984 11.941Z" fill="url(#paint1_linear_4874_2209)"/>
          <defs>
            <linearGradient id="paint0_linear_4874_2209" x1="55.6907" y1="53.7251" x2="55.6907" y2="96.1465" gradientUnits="userSpaceOnUse">
              <stop stop-color="#41FB96"/>
              <stop offset="1" stop-color="#12A053"/>
            </linearGradient>
            <linearGradient id="paint1_linear_4874_2209" x1="53.3494" y1="9.99854" x2="53.3494" y2="52.4489" gradientUnits="userSpaceOnUse">
              <stop stop-color="#41FB96"/>
              <stop offset="1" stop-color="#12A053"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="flyGreenBooking__list">
        <div class="flyGreenBooking__list-item">
          <div class="flyGreenBooking__list-item-title" style="font-size: 12.8px">Carbon emissions generated from flight:</div>
          <div class="flyGreenBooking__list-item-value" style="font-size: 12.8px"><span class="value">{{ carbonEmissionsGenerated }}</span>kg</div>
        </div>
        <div class="flyGreenBooking__list-item">
          <div class="flyGreenBooking__list-item-title" style="font-size: 12.8px">Distance <span>(nm)</span>:
          </div>
          <div class="flyGreenBooking__list-item-value" style="font-size: 12.8px">{{ distance }}</div>
        </div>
        <div class="flyGreenBooking__list-item">
          <div class="flyGreenBooking__list-item-title" style="font-size: 12.8px">Amount of emissions offset given purchase:</div>
          <div class="flyGreenBooking__list-item-value" style="font-size: 12.8px"><span class="value">{{ carbonEmissionsPurchased }}</span>kg</div>
        </div>
      </div>
      <div class="flyGreenBooking__percentage">
        <div class="flyGreenBooking__percentage-title">Percentage of total emissions offset:</div>
        <div class="flyGreenBooking__percentage-value js-percent-value" :data-value="percentEmissions" ref="persent">
          <span class="text" style="font-size: 12.8px">{{ Math.round(percentEmissions) }}%</span>
          <span class="icon">
          <svg viewBox="0 0 91 91" fill="none">
            <circle id="circle-bg" cx="43.5" cy="47.5" r="43.5" fill="#52E495" fill-opacity="0.2"></circle>
            <circle ref="persentLine" class="js-percent-line" id="circle-line" cx="43.5" cy="47.5" r="41.5"
                    fill="none" stroke-width="4"
                    stroke="url(#gradient)"></circle>
            <linearGradient id="gradient" x1="66" y1="2" x2="66" y2="46.5" gradientUnits="userSpaceOnUse">
              <stop stop-color="#41FB96"></stop>
              <stop offset="1" stop-color="#12A053"></stop>
            </linearGradient>
          </svg>
          </span>
        </div>
      </div>
    </div>
    <div class="flyGreenBooking__right" style="padding-top: 9%; margin-bottom:auto;">
              <div class="flyGreenBooking__amount">
          <span class="flyGreenBooking__amount-title" style="color:black;">Desired Purchase Value of Carbon Offsets:</span>
          <span style="border-bottom: 1px solid #d6d6d6;">
              <span style="color:#12A053;">$</span>
              <input v-on:input="updatePurchaseValue($event.target.value)" :value="purchaseValue" class="flyGreenBooking__list-item-value input form__field js-numberOnly" style="display:inline-block; width:20%; padding-left:1%; color:#12A053; border-bottom: none" />
          </span>
           </div>
      <div class="flyGreenBooking__amount">
        <span class="flyGreenBooking__amount-title">Purchase value to offset 100% emissions:</span>
      <span class="flyGreenBooking__list-item-value" style="color:black;">
        <span class="value currency">$</span>
<!--        <input style="margin-left: 4px;">{{ priceForEntireOffset }}</>-->
        <input :value="priceForEntireOffset" class="flyGreenBooking__list-item-value input form__field js-numberOnly" readonly style="display:inline-block; width:20%; padding-left:1%; border-bottom: none" />
      </span>
      </div>
      <div class="flyGreenBooking__info">FLYJETS is committed to our FLYGreen Energy Initiative, and we want
        to work with you as a member of TEAM GREEN. With each flight booking, we will offer additional FLYRewards
        - over and above the amount ordinarily granted with each flight
        - to those users who elect to offset expected emissions from their trip with
        carbon offsets, and/or fly with some amount of Sustainable Aviation Fuel (SAF), pending availability.
      </div>
      <!-- <div class="flyGreenBooking__form">
        <form
          class="form form--flyGreen js-flyGreenForm"
          :class="{'loading' : loading}"
          data-action="flyGreen"
          id="flyGreenForm"
          @submit.prevent="submitHandler"
        >
          <label class="form__label form__label--checkbox">
            <input class="form__checkbox" type="checkbox" v-model="switchForm"/>
            <span class="form__checkbox-box">Offset Additional Emissions?</span>
            <i class="form__checkbox-icon"></i>
          </label>
          <div class="form__radioGroup">

            <div class="form__labelGroup">
              <label class="form__label form__label--radio">
                <input class="form__radio" type="radio" v-model="offset" value="tripEmissions"/>
                <i class="form__radio-icon"></i>
                <span class="form__radio-box">Offset additional</span>
                <div class="form__field-wrapper">
                  <input
                    class="form__field js-numberOnly"
                    type="text"
                    v-model="percentEmissions"
                    autocomplete="off"
                    placeholder="number"
                    data-type="trip emissions"
                    @input="percentEmissionsValidate"
                    @blur="percentEmissionsToInt"
                  />
                </div>
                <span
                  v-if="$v.percentEmissions.$dirty && !$v.percentEmissions.required"
                  class="form__field-invalid"
                >
                  This field is required
                </span>
                <div class="form__caption">percent of total trip emissions</div>
              </label>
            </div>

            <div class="form__labelGroup">
              <label class="form__label form__label--radio">
                <input class="form__radio" type="radio" v-model="offset" value="carbonEmissions"/>
                <i class="form__radio-icon"></i>
                <span class="form__radio-box">Offset additional carbon emissions equivalent to</span>
                <div class="form__field-wrapper">
                  <input
                    class="form__field js-numberOnly"
                    type="text"
                    data-type="carbon emissions"
                    v-model="carbonEmissions"
                    autocomplete="off"
                    placeholder="number"
                    @input="carbonEmissionsValidate"
                    @blur="carbonEmissionsRemoveDotFormEnd"
                  />
                </div>
                <span
                  v-if="$v.carbonEmissions.$dirty && !$v.carbonEmissions.required"
                  class="form__field-invalid"
                >
                  This field is required
                </span>
              </label>
            </div>
          </div>
        </form>
      </div> -->
    </div>
    <!-- <div class="flyGreenBooking__footer js-flyGreenForm-button-wr" :class="{'loading' : loading}">
      <Spinner/>
      <button class="form__button" :disabled="loading" form="flyGreenForm" @click="complete">
        <span class="text">Complete</span>
      </button>
    </div> -->
  </div>
</template>

<script>
  // import Spinner from '@/components/common/Spinner/Spinner'
  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'FlyGreenCalc',
    data: () => ({
      switchForm: true,
      offset: 'tripEmissions',
      carbonEmissionsGenerated: 0,
      distance: 0,
      purchaseValue: 0,
      carbonEmissionsPurchased: 0,
      priceForEntireOffset: 0,
      percentEmissions: 100,
      loading: false,
      ops: {
        rail: {
          size: '3px',
        },
        bar: {
          size: '3px',
          background: 'rgba(0,0,0,0.1)',
        },
      },
      bookingId: null,
    }),
    validations: {
      percentEmissions: { required },
      carbonEmissions: { required },
    },
    computed: {
      bookingData () {
        return this.$store.state.bookingFromSearch
      },
    },
    created () {
      // console.log(this.$store.state.bookingFromSearch.fullBookingItem)
      this.bookingId = this.$store.state.bookingFromSearch.fullBookingItem.id
    },
    async mounted () {
      const response = await this.$store.dispatch('getFlyGreenData')

      const { totalEmissions, priceForEntireOffset, distance } = response.data

      this.distance = distance;
      this.carbonEmissionsGenerated = totalEmissions;
      this.priceForEntireOffset = priceForEntireOffset;
      this.purchaseValue = priceForEntireOffset;
      this.carbonEmissionsPurchased = this.purchaseValue / this.priceForEntireOffset * this.carbonEmissionsGenerated;

      this.setPercentLine();

      await this.$store.dispatch('storeOffsetPurchasePayload', {
        offsetPercentage: 100.00,
        offsetPrice: priceForEntireOffset,
        bookingId: this.bookingId,
      })
    },
    methods: {
      async updatePurchaseValue (val) {
        // console.log('"updatePurchaseValue" ran')

        if (val < 0) {
          val = this.priceForEntireOffset;
        }

        this.purchaseValue = val;
        this.percentEmissions = (100 * this.purchaseValue / (this.priceForEntireOffset)).toFixed(2)
        this.carbonEmissionsPurchased = Math.floor((this.purchaseValue / this.priceForEntireOffset * this.carbonEmissionsGenerated))

        this.setPercentLine();

        await this.$store.dispatch('storeOffsetPurchasePayload', {
          offsetPercentage: this.percentEmissions,
          offsetPrice: Number(val).toFixed(2),
          // bookingId: this.bookingId
        })
      },
      setCarbonEmissionsGenerated () {
        this.carbonEmissionsGenerated = this.$store.state.flygreen.carbonEmissionsGenerated
      },
      setPurchaseValue () {
        this.purchaseValue = this.$store.state.flygreen.purchaseValue
      },
      setPercentEmissions () {
        this.percentEmissions = this.$store.state.flygreen.percentEmissions
      },
      setPercentLine () {
        this.$refs.persentLine.style.strokeDashoffset = 261 * (+this.percentEmissions) / 100 - 261
      },
      setCarbonEmissions () {
        this.carbonEmissions = this.$store.state.flygreen.carbonEmissions
      },
      changePurchaseValue () {
        this.$store.commit('changePurchaseValue')
        this.setPurchaseValue()
      },
      changeCarbonEmissions (value) {
        this.$store.commit('changeCarbonEmissions', value)
        this.setCarbonEmissions()
      },
      changePercentEmissions (value) {
        this.$store.commit('changePercentEmissions', value)
        this.setPercentEmissions()
      },
      percentEmissionsValidate (e) {
        this.percentEmissions = e.target.value.replace(/^0\d|[^0-9]/g, (i) => {
          if (i.length > 1) {
            return +i
          } else {
            return ''
          }
        })

        if (+this.percentEmissions > 100) {
          this.percentEmissions = 100
        }

        this.changeCarbonEmissions(this.percentEmissions)
        this.setPercentLine()
        this.changePurchaseValue()
      },
      carbonEmissionsValidate (e) {
        let counter = 0

        this.carbonEmissions = e.target.value.replace(/^0\d|[^0-9]/g, (i) => {
          if (i === '.') {
            if (counter === 0 && this.carbonEmissions.toString().indexOf(i) !== 0) {
              counter++
              return i
            } else {
              return ''
            }
          } else if (i.length > 1) {
            return +i
          } else {
            return ''
          }
        })

        const carbToStr = this.carbonEmissions.toString()
        const idxOfCarb = carbToStr.indexOf('.')

        if (idxOfCarb !== -1 && carbToStr.length > idxOfCarb + 2) {
          this.carbonEmissions = carbToStr.substr(0, carbToStr.length - 1)
        }

        if (this.carbonEmissions > this.carbonEmissionsGenerated) {
          this.carbonEmissions = this.carbonEmissionsGenerated
        }

        this.changePercentEmissions(this.carbonEmissions)
        this.setPercentLine()
        this.changePurchaseValue()
      },
      percentEmissionsToInt () {
        this.percentEmissions = +this.percentEmissions
        this.changePercentEmissions(this.carbonEmissions)
      },
      carbonEmissionsRemoveDotFormEnd () {
        this.carbonEmissions = +this.carbonEmissions.toString().replace(/$\./)
        this.changeCarbonEmissions(this.percentEmissions)
      },
      setFocusOnInput (event) {
        event.target.focus()
      },
      submitHandler () {
        // if (this.$v.percentEmissions.$invalid && this.$v.carbonEmissions.$invalid) {
        //   this.$v.$touch()
        //   return false
        // }

        // this.loading = true
      },
      async complete () {
        this.$modal.hide('FlyGreenPopup')
        const message = {
          title: null,
          text: null,
        }

        if (this.bookingData.terms) {
          const result = await this.$store.dispatch('confirmBooking')
          if (result) {
            this.$modal.show('ThanksPopup', {message})

            message.title = 'Booking Created'
            message.text = 'Your booking request has been created successfully. We will reach out to you and to the Aircraft Provider to confirm.'
          }
        } else {
          message.title = null
          message.text = 'Please accept the terms before confirming!'
        }

        this.$modal.show('ThanksPopup', {message})
      },
    },
    components: {
      // Spinner
    },
  }
</script>
